export const NO_ETH_BROWSER_WALLET = "No ethereum browser crypto wallet found. Please install one. MetaMask is a great choice."
export const FAILED_TO_CONNECT = "Failed to connect site to account"